
const _ = require('lodash');

module.exports = {
  log: (value) => console.log(JSON.stringify(value, null, '\t')),

  non_destructive_sort: (value) =>{
    return value.slice().sort(function(a,b){
      if( a < b ) return -1;
      if( a > b ) return 1;
      return 0;
    });
  },

  ua: () => {
    const u = window.navigator.userAgent.toLowerCase();
    return {
      Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
      || u.indexOf("ipad") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
      || u.indexOf("kindle") != -1
      || u.indexOf("silk") != -1
      || u.indexOf("playbook") != -1,
      Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
      || u.indexOf("iphone") != -1
      || u.indexOf("ipod") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
      || u.indexOf("blackberry") != -1,
      Android: u.indexOf("android") != -1 && u.indexOf("mobile") != -1,
      iPhone: u.indexOf("iphone") != -1
    }
  },
  browser: () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIE = (userAgent.indexOf('msie') >= 0
      || userAgent.indexOf('trident') >= 0);
    if (isIE) {
      const arr = /(msie|rv:?)\s?([\d\.]+)/.exec(userAgent);
      const version = (arr) ? arr[2] : '';
      return 'ie' + version;
    } else {
      if (userAgent.indexOf('edge') != -1) {
        return 'edge';
      } else if (userAgent.indexOf('chrome') != -1) {
        return 'chrome';
      } else if (userAgent.indexOf('firefox') != -1) {
        return 'firefox';
      } else if (userAgent.indexOf('safari') != -1) {
        return 'safari';
      } else if (userAgent.indexOf('opera') != -1) {
        return 'opera';
      } else if (userAgent.indexOf('gecko') != -1) {
        return 'gecko';
      } else {
        return false;
      }
    }
  },
  wareki: (y) => {
    let s = '';
    if (y > 1988) {
      s = "平成" + (y - 1988) + "年";
    } else if (y > 1925) {
      s = "昭和" + (y - 1925) + "年";
    } else if (y > 1911) {
      s = "大正" + (y - 1911) + "年";
    } else if (y > 1867) {
      s = "明治" + (y - 1867) + "年";
    }
    return s;
  },
  depth0: (data) => {
    return _.filter(data, function(o) { return o.depth === 0 })
  },
  depth1: (data) => {
    return _.filter(data, function(o) { return o.depth === 1 })
  },
  depth2: (data) => {
    return _.filter(data, function(o) { return o.depth === 2 })
  },
  children: (data, id) => {
    const parent = data[id]
    return _.filter(data, function(o) {
      return o.depth === parent.depth + 1 && o.parent_id === parent.id
    })
  },
};
